export default "__VITE_ASSET__CtdnArCb__"